<template>
  <el-select
    :disabled="disabled"
    v-model="selectedRecord"
    :remote-method="loadRecords"
    :loading="loading"
    :placeholder="placeholder"
    class="select-info flex-grow-1"
    filterable
    clearable
    remote
    @input="$emit('input', $event)"
  >
    <el-option
      v-for="record in records"
      :key="record.id"
      :label="record.name"
      :value="record.id"
      class="select-info"
    />
  </el-select>
</template>

<script>
export default {
  props: ['value', 'disabled', 'placeholder'],
  data() {
    return {
      loading: false,
      selectedRecord: {},
      records: [],
    };
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        this.selectedRecord = newValue;
      },
    },
  },
  methods: {
    loadRecords(query) {
      if (query !== '') {
        this.loading = true;
        this.$http
          .get(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/committeeEntities/search/fulltext?name=${query}&acronym=${query}&page=0&size=10`,
          )
          .then(response => {
            this.loading = false;
            this.records = response.data._embedded.committeeEntities;
          });
      } else {
        this.records = [];
      }
    },
  },
};
</script>

<style scoped></style>
